var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5274,8.6067L8.9949,1.8656L15.4624,8.6067H2.5274ZM13.3247,16.4551H9.7355V13.9626C9.7355,13.5351 9.4047,13.1901 8.9949,13.1901C8.5851,13.1901 8.2544,13.5351 8.2544,13.9626V16.4551H4.6651V10.1517H13.3247V16.4551ZM17.7038,8.7663L9.5182,0.2279C9.2319,-0.076 8.7628,-0.076 8.4716,0.2279L0.2169,8.8333C0.0046,9.0547 -0.0596,9.3895 0.0589,9.6778C0.1724,9.9662 0.444,10.1516 0.7402,10.1516H3.184V17.2275C3.184,17.655 3.5148,18 3.9246,18H14.0652C14.475,18 14.8057,17.655 14.8057,17.2275V10.1516H17.2496H17.2594C17.6692,10.1516 18,9.8066 18,9.3792C18,9.1268 17.8815,8.9054 17.7038,8.7663Z",
    fill: "#6E6E7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.87039a0eb7f85ca558496bf14757140a.svg";
export { ForwardRef as ReactComponent };